import { React, useState, useCallback, useMemo, useEffect } from "react";

// CSS
import "./itemPicker.css";

// Components
import ItemView from "./itemView";

//Hooks
import { generateItemsQRCodeValue } from "../../hooks/qrCodeCreator";

export default function ItemPicker({
  Title = "Items",
  bShowAll = false,
  WarehouseID = -1,
  ClientID = -1,
  updateTotalPrice,
  onSelectedItemsChange,
  onSelectionItemAmountsChange,
  bDisabled = false,
  noteType = "Sale",
  bLimitAmount = false,
  disabledMsg = "Select a warehouse and client first.",
  onQRCodeValueChange = (i) => {},
  initialSelectionItemAmounts = new Map(),
}) {
  const [selectionItemAmounts, setSelectionItemAmounts] = useState(new Map());

  const qrCodeValue = useMemo(() => {
    return generateItemsQRCodeValue(
      selectionItemAmounts,
      WarehouseID,
      ClientID
    );
  }, [generateItemsQRCodeValue, selectionItemAmounts, WarehouseID, ClientID]);

  useEffect(() => {
    if (onQRCodeValueChange) {
      onQRCodeValueChange(qrCodeValue);
    }
  }, [qrCodeValue, onQRCodeValueChange]);

  return (
    <div className="item-picker-container">
      <ItemView
        Tit={Title}
        bShowAll={bShowAll}
        WarehouseID={WarehouseID}
        ClientID={ClientID}
        bEnableCreate={false}
        bEnableEdit={false}
        bCountable={true}
        bLimitAmount={bLimitAmount}
        btnSectionWidth={2}
        updateTotalPrice={updateTotalPrice}
        onSelectedItemsChange={onSelectedItemsChange}
        onSelectionItemAmountsChange={onSelectionItemAmountsChange}
        initialSelectionItemAmounts={initialSelectionItemAmounts}
        bDisabled={bDisabled}
        noteType={noteType}
        disabledMsg={disabledMsg}
        bEnableExport={false}
        propertiesToShow={{
          ID: { Show: true, Width: 2 },
          Barcode: { Show: true, Width: 2 },
          Name: { Show: true, Width: 3 },
          Unit: { Show: false, Width: 2 },
          Price: { Show: true, Width: 2 },
          Tags: { Show: true, Width: 4 },
          Clients: { Show: false, Width: 2 },
          Amount: { Show: true, Width: 2 },
        }}
      ></ItemView>
    </div>
  );
}
